import {Component, OnDestroy, OnInit} from '@angular/core';

import {WishlistService} from 'src/app/shared/services/wishlist.service';
import {AuthenticationService} from '../../../../services/authentication.service';
import {User} from '../../../../classes/app.models';
import {ModalService} from '../../../../services/modal.service';

@Component({
    selector: 'indiapicture-wishlist-menu',
    templateUrl: './wishlist-menu.component.html',
    styleUrls: ['./wishlist-menu.component.scss']
})

export class WishlistMenuComponent implements OnInit, OnDestroy {
    currentUser: User;

    constructor(public wishlistService: WishlistService, private authenticationService: AuthenticationService,
                private modalService: ModalService) {
        this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    }

    ngOnInit(): void {
    }

    showLoginModal(event: Event): void {
        event.preventDefault();
        this.modalService.showLoginModal();
    }

    ngOnDestroy(): void {
    }
}
